<template>
  <modal :title="`${deviceTypeConvert(type)}${$t('public.data')}${$t('public.detail')}`"
     :visible.sync="isShowDialog" width="1200px" @close="close">
    <!-- 总数 -->
    <div style="text-align:right;">
      {{ $t('public.total_num') }}
      {{ count.total }}
      <span class="ml-10">
        {{ $t('public.online') }}
        {{ count.online }}
      </span>
      <span class="ml-10">
        {{ $t('public.offline') }}
        {{ count.offline }}
      </span>
      <span class="ml-10">
        {{ $t('public.stop') }}
        {{ count.stop }}
      </span>
      <span class="ml-10">
        {{ $t('public.unconfirm') }}
        {{ count.unconfirm }}
      </span>
    </div>
    <el-divider></el-divider>

    <div v-for="(item, index) in detailList" :key="index" style="margin:20px 0;">
      <div class="bg-theme color-white"
       style="width: 50%;text-align:center; height:30px;line-height:30px;">
       {{ item.scene.name }}
      </div>
      <div class="uk-flex">
      <el-table
        :data="item.data"
        border
        show-summary
        :sum-text="$t('public.total')"
        style="width: 50%; float:left;">
        <el-table-column
          :label="$t('public.device')"
          width="150"
          >
          <template  slot-scope="scope">
            <span v-if="type === 'sensor'">{{ sensorTypeConvertGroup(scope.row.type).title }}</span>
            <span v-if="type === 'display'">{{ $t(displayscreenTypeConvert(scope.row.type).title) }}</span>
            <span v-if="type === 'gateway'">{{ $t(gatewayTypeConvert(scope.row.type).title) }}</span>
            <span v-if="type === 'relay'">{{ $t(relayTypeConvert(scope.row.type).title) }}</span>
            <span v-if="type === 'gas'">{{ $t(gasTypeConvert(scope.row.type).title) }}</span>
            <span v-if="type === 'magnetism'">{{ $t(magnetismTypeConvert(scope.row.type).title) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="onLine"
          :label="$t('public.online')"
         >
        </el-table-column>
        <el-table-column
          prop="offLine"
          :label="$t('public.offline')">
        </el-table-column>
        <el-table-column
          prop="stopCount"
          width="95px"
          :label="$t('public.stop')">
        </el-table-column>
        <el-table-column
          prop="unknownCount"
          width="110px"
          :label="$t('public.unconfirm')">
        </el-table-column>
        <el-table-column
          prop="totalCount"
          :label="$t('public.total_num')">
        </el-table-column>
      </el-table>
      <div style="width:50%" class="uk-flex">
        <pieEchart :chartData="setPieDeviceStatus(item.data)"/>
        <pieEchart :chartData="setPieDeviceType(item.data)"/>
      </div>
      </div>
    </div>
  </modal>
</template>
<script>
import { getDeviceDetail } from '@/api/modules/overview.js'
import { sensorType, sensorTypeConvert } from '@/utils/dict/sensor'
import { deviceTypeConvert, deviceStatusConvert,
  displayscreenTypeConvert, gatewayTypeConvert, relayTypeConvert,
  gasTypeConvert, magnetismTypeConvert } from '@/utils/convert.js'
import pieEchart from '@/components/echart/pieEchart.vue';

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    sceneIds: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    pieEchart,
  },
  data(){
    return {
      detailList: [],

      sensorTypeConvert,
      deviceTypeConvert,
      displayscreenTypeConvert,
      gatewayTypeConvert,
      relayTypeConvert,
      gasTypeConvert,
      magnetismTypeConvert
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    // 计算总数、在线等各种数量
    count(){
      let count = {
        total: 0,
        online: 0,
        offline: 0,
        stop: 0,
        unconfirm: 0
      }
      this.detailList.forEach(item => {
        item.data.forEach(d => {
          count.total = count.total + d.totalCount
          count.online = count.online + d.onLine
          count.offline = count.offline + d.offLine
          count.stop = count.stop + d.stopCount
          count.unconfirm = count.unconfirm + d.unknownCount
        })
      });
      return count
    },

  },
  created(){
    this.getDetail()
  },
  methods: {
    getDetail(){
      getDeviceDetail(this.type, { scenes: this.sceneIds.join() }).then(res => {
        if (res.state.code === 200) {
          // 整理数据；显示大类，一代温度计/二代温度计这种（传感器需求整理，其他不用）
          if(this.type === 'sensor'){
            // 31:温度计；32:温湿度计；33：二代温度计；34：二代温湿度计；35：4G温度计；36:4G温湿度计
            res.result.forEach(_ => {
              let list = []
              let data = _.data
              data.forEach(item => {
                if(item.type === 1 || item.type === 3 || item.type === 5){
                  let index1 = list.findIndex(_ => _.type === 31)
                  if( index1 === -1 ){
                    list.push({
                      ...item,
                      type: 31,
                    })
                  }else{
                    list[index1].onLine += item.onLine
                    list[index1].offLine += item.offLine
                    list[index1].stopCount += item.stopCount
                    list[index1].totalCount += item.totalCount
                    list[index1].unknownCount += item.unknownCount
                  }
                }else if(item.type === 2 || item.type === 4 || item.type === 6){
                  let index2 = list.findIndex(_ => _.type === 32)
                  if( index2 === -1 ){
                    list.push({
                      ...item,
                      type: 32,
                    })
                  }else{
                    list[index2].onLine += item.onLine
                    list[index2].offLine += item.offLine
                    list[index2].stopCount += item.stopCount
                    list[index2].totalCount += item.totalCount
                    list[index2].unknownCount += item.unknownCount
                  }
                }else if(item.type === 7){
                  list.push({
                    ...item,
                    type: 33,
                  })
                }else if(item.type === 8){
                  list.push({
                      ...item,
                      type: 34,
                    })
                }else if(item.type === 9 || item.type === 11){
                  let index3 = list.findIndex(_ => _.type === 35)
                  if( index3 === -1 ){
                    list.push({
                      ...item,
                      type: 35,
                    })
                  }else{
                    list[index3].onLine += item.onLine
                    list[index3].offLine += item.offLine
                    list[index3].stopCount += item.stopCount
                    list[index3].totalCount += item.totalCount
                    list[index3].unknownCount += item.unknownCount
                  }
                }else{
                  let index4 = list.findIndex(_ => _.type === 36)
                  if( index4 === -1 ){
                    list.push({
                      ...item,
                      type: 36,
                    })
                  }else{
                    list[index4].onLine += item.onLine
                    list[index4].offLine += item.offLine
                    list[index4].stopCount += item.stopCount
                    list[index4].totalCount += item.totalCount
                    list[index4].unknownCount += item.unknownCount
                  }
                }
              })
              _.data = list

            })

            this.detailList = res.result

            console.log(' this.detailList =',  this.detailList )

          }else{
            this.detailList = res.result

          }

        }
      })
    },
    close(){
      this.$emit('close')
    },
    // 整理设备类型饼图数据
    setPieDeviceType(item){
      // 整理构造饼图数据
      let pieSeries = []

      item.forEach(i => {
        let name = ''
        switch (this.type){
          case 'sensor':
            name = this.sensorTypeConvertGroup(i.type).title
            break
          case 'display':
            name = this.$t(displayscreenTypeConvert(i.type).title)
            break
          case 'gateway':
            name = this.$t(gatewayTypeConvert(i.type).title)
            break
          case 'relay':
            name = this.$t(relayTypeConvert(i.type).title)
            break
          case 'gas':
            name = this.$t(gasTypeConvert(i.type).title)
            break
          case 'magnetism':
            name = this.$t(magnetismTypeConvert(i.type).title)
            break
        }
        pieSeries.push({
            name: name,
            value: i.totalCount
          })
      })
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: this.$t('integration.equipment_type'),
          name: ''
        }
      }
    },
    // 整理设备状态饼图数据
    setPieDeviceStatus(item){
      // 整理构造饼图数据
      let pieSeries = []
      if(item.length){
        let count = {
          onLine: 0,
          offLine: 0,
          stopCount: 0,
          unknownCount: 0
        }

        item.forEach(i => {
          count.onLine = count.onLine + i.onLine
          count.offLine = count.offLine + i.offLine
          count.stopCount = count.stopCount + i.stopCount
          count.unknownCount = count.unknownCount + i.unknownCount

        })

        for(let key in count){
          pieSeries.push({
            name: deviceStatusConvert(key),
            value: count[key]
          })
        }
      }

      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: this.$t('integration.equipment') + this.$t('integration.state'),
          name: ''
        }
      }
    },
    // 传感器大类转换
    sensorTypeConvertGroup(group){
      switch(group){
        case 31:
          return {title: this.$t('text.Thermograph')}
        case 32:
          return {title: this.$t('text.Thermometer')}
        case 33:
          return {title: this.$t('text.Thermograph2')}
        case 34:
          return {title: this.$t('text.Thermometer2')}
        case 35:
          return {title: this.$t('sensorType.FourGTemp')}
        case 36:
          return {title: this.$t('sensorType.FourGTempHum')}

      }
    }

  }
}
</script>
<style lang="scss" scoped>
.echarts {
  width: 50% !important;
  height: 250px !important;
}
</style>
